import { render } from "./EmailGenerator.vue?vue&type=template&id=763fa45c&ts=true"
import script from "./EmailGenerator.vue?vue&type=script&lang=ts"
export * from "./EmailGenerator.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__